/* Copyright (c) 2025 Xperi. All Rights Reserved.  */

import {
    ChannelsApi,
    ChannelsGetV2Request,
    Configuration,
    ConfigurationParameters,
} from 'client-code/channels-service';

import { APPLICATION_FEATURE_AREA } from '../../config';
import { CommonHeaders } from '../CommonHeaders';
import { Constants } from '../constants';
import { Channels } from '../entities';
import { Log } from '../logging/Log';
import { TServicesParams } from '../types/TServicesParams';

export class ChannelsServiceRepositoryImplV2 {
    private readonly TAG: string = 'ChannelsServiceRepositoryImplV2';

    private readonly mParams: TServicesParams;

    public constructor(params: TServicesParams) {
        this.mParams = params;
    }

    /**
     * get channels from server
     * @returns Channels
     */
    public async getChannelsFromServer(
        isFavorite: boolean = false,
        isReceived: boolean = false,
    ): Promise<Channels> {
        try {
            const commonHeaders = new CommonHeaders(APPLICATION_FEATURE_AREA.GUIDE).headers;

            const configurationParameters: ConfigurationParameters = {
                apiKey: this.mParams.accessToken,
                basePath: this.mParams.basePath,
                baseOptions: {
                    timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                    headers: commonHeaders,
                },
            };
            const requestParameters: ChannelsGetV2Request = {
                acceptLanguage: commonHeaders['Accept-Language'],
                applicationFeatureArea: commonHeaders.ApplicationFeatureArea,
                applicationVersion: commonHeaders.ApplicationVersion,
                deviceType: commonHeaders.DeviceType,
                productName: commonHeaders.ProductName,
                applicationName: commonHeaders.ApplicationName,
                bodyId: this.mParams.bodyId,
                isFavorite,
                isReceived,
                whiny: this.mParams.whiny || 'false',
            };
            const configuration = new Configuration(configurationParameters);
            const channelsService = new ChannelsApi(configuration);
            const serviceResponse = await channelsService.channelsGetV2(requestParameters);

            return new Channels({
                ...serviceResponse.data,
            });
        } catch (error) {
            Log.e(this.TAG, 'getChannels() - failed to fetch channels data', error);
            throw error;
        }
    }
}
